/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Footer_TermsInputs */

const zh_landing_footer_terms = /** @type {(inputs: Landing_Footer_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`服务条款`)
};

const en_landing_footer_terms = /** @type {(inputs: Landing_Footer_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terms`)
};

const es_landing_footer_terms = /** @type {(inputs: Landing_Footer_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Términos`)
};

/**
* | output |
* | --- |
* | "Terms" |
*
* @param {Landing_Footer_TermsInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const landing_footer_terms = /** @type {((inputs?: Landing_Footer_TermsInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Footer_TermsInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_landing_footer_terms(inputs)
	if (locale === "en") return en_landing_footer_terms(inputs)
	return es_landing_footer_terms(inputs)
});